// CalibrationLogBook.js
// The container model for a standalone Calibration Log Book (book metadata + calibration entries).
import { v4 as uuidv4 } from "uuid";
import { CalibrationLogBookEntry } from "./CalibrationLogBookEntry";

export class CalibrationLogBook {
  constructor(data = {}) {
    this.id = data.id || uuidv4();
    this.bookName = data.book_name || "";
    this.bookDate = data.book_date || null;
    this.status = data.status || "active";
    this.completed = data.completed || false;
    this.completedDate = data.completed_date || null;
    this.completedTime = data.completed_time || null;
    this.completedBy = data.completed_by || null;
    this.completedByName = data.completed_by_name || "";
    this.createdBy = data.created_by || null;
    this.createdByName = data.created_by_name || "";
    this.projectNumber = data.project_number || null;
    this.phaseId = data.phase_id || null;
    this.taskId = data.task_id || null;
    this.samplingEventId = data.sampling_event_id || null;
    this.createdAt = data.created_at || null;
    this.updatedAt = data.updated_at || null;

    // Calibration entries
    this.entries =
      data.entries && data.entries.length > 0
        ? data.entries.map((entry) => new CalibrationLogBookEntry(entry))
        : [];
  }

  setBookName(bookName) {
    this.bookName = bookName || "";
  }

  setBookDate(bookDate) {
    this.bookDate = bookDate || null;
  }

  setProjectNumber(projectNumber) {
    this.projectNumber = projectNumber || null;
  }

  setPhaseId(phaseId) {
    this.phaseId = phaseId || null;
  }

  setTaskId(taskId) {
    this.taskId = taskId || null;
  }

  getEntryById(entryId) {
    return this.entries.find((entry) => entry.id === entryId);
  }

  addEntry(entry) {
    this.entries.push(entry);
    return entry;
  }

  removeEntry(entryId) {
    this.entries = this.entries.filter((entry) => entry.id !== entryId);
  }

  // Sort entries by date (desc) then time (asc) - mirrors SamplingEvent.sortWaterCalibrationLogs.
  sortEntries() {
    if (!this.entries || this.entries.length === 0) {
      return [];
    }
    this.entries.sort((a, b) => {
      const dateA = a.calibrationDate ? new Date(a.calibrationDate) : new Date(0);
      const dateB = b.calibrationDate ? new Date(b.calibrationDate) : new Date(0);
      if (dateA > dateB) return -1;
      if (dateA < dateB) return 1;
      if (a.calibrationTime && b.calibrationTime) {
        return a.calibrationTime.localeCompare(b.calibrationTime);
      }
      return 0;
    });
    return this.entries;
  }

  toJson() {
    return {
      id: this.id,
      book_name: this.bookName,
      book_date: this.bookDate,
      status: this.status,
      completed: this.completed,
      completed_date: this.completedDate,
      completed_time: this.completedTime,
      completed_by: this.completedBy,
      created_by: this.createdBy,
      project_number: this.projectNumber,
      phase_id: this.phaseId,
      task_id: this.taskId,
      sampling_event_id: this.samplingEventId,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
      entries: this.entries.map((entry) => entry.toJson()),
    };
  }
}
